/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Xml_Deep_P1Inputs */

const en_to_xml_deep_p1 = /** @type {(inputs: To_Xml_Deep_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XML element names are far more restrictive than JSON keys. A JSON key can be any string at all, including an empty one, while an XML name may only contain letters, digits, hyphens, underscores, and periods, and may not begin with a digit or a hyphen. A key like my key or a.b therefore cannot be used directly, and the converter replaces the characters XML rejects with underscores, giving my_key and a_b.`)
};

const ko_to_xml_deep_p1 = /** @type {(inputs: To_Xml_Deep_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XML 요소 이름은 JSON 키보다 훨씬 제약이 많습니다. JSON 키는 빈 문자열을 포함해 어떤 문자열이든 될 수 있지만, XML 이름은 글자, 숫자, 하이픈, 밑줄, 마침표만 담을 수 있고 숫자나 하이픈으로 시작할 수 없습니다. 따라서 my key나 a.b 같은 키는 그대로 쓸 수 없으며, 변환기는 XML이 거부하는 문자를 밑줄로 바꿔 my_key와 a_b를 만듭니다.`)
};

const ja_to_xml_deep_p1 = /** @type {(inputs: To_Xml_Deep_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XML の要素名は JSON のキーよりはるかに制約が厳しいです。JSON のキーは空文字列を含めどんな文字列でもよいのに対し、XML の名前は英字、数字、ハイフン、アンダースコア、ピリオドだけを含められ、数字やハイフンで始めることはできません。したがって my key や a.b のようなキーはそのまま使えず、変換器は XML が拒む文字をアンダースコアに置き換えて my_key と a_b にします。`)
};

/**
* | output |
* | --- |
* | "XML element names are far more restrictive than JSON keys. A JSON key can be any string at all, including an empty one, while an XML name may only contain le..." |
*
* @param {To_Xml_Deep_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_xml_deep_p1 = /** @type {((inputs?: To_Xml_Deep_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Xml_Deep_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_xml_deep_p1(inputs)
	if (locale === "ko") return ko_to_xml_deep_p1(inputs)
	return ja_to_xml_deep_p1(inputs)
});